<label class="if-switch-label" [class.if-switch-label--disabled]="isDisabled()">
  <input
    type="checkbox"
    role="switch"
    class="if-switch-input"
    [checked]="checked()"
    [disabled]="isDisabled()"
    [attr.aria-label]="ariaLabel()"
    (change)="onInputChange($event)"
    (blur)="onBlur()" />
  <span class="if-switch" [class.if-sm]="size() === 'sm'" aria-hidden="true"></span>
  @if (label()) {
    <span class="if-switch-text">{{ label() }}</span>
  }
</label>
